import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { OrigemPipe } from './origem.pipe';
import { OrigemIconPipe } from './origem-icon.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        OrigemPipe,
        OrigemIconPipe
    ],
    exports: [
        OrigemPipe,
        OrigemIconPipe
    ],
    providers: [
        OrigemPipe,
        OrigemIconPipe
    ]
})
export class OrigemPipeModule { }
